import "./Intelligence.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EconomicIntelligenceHub from "./sections/EconomicIntelligenceHub";
import StateMarketRankings from "./sections/StateMarketRankings";
import AdvocacyInAction from "./sections/AdvocacyInAction";
import FooterInformation from "@/reusable_sections/Footer";
export default function IntelligencePage() {
  return <div>
      <MainNavigation />
      <EconomicIntelligenceHub />
      <StateMarketRankings />
      <AdvocacyInAction />
      <FooterInformation />
    </div>;
}